<template>
    <div class="h-100 w-100 mt-5 align-self-center text-center">
        <navbar/>
        <p>...</p>
        <footer/>
<!--        <p>if it takes longer than 15 seconds <a href="/">click here</a> to go back manually</p>-->
    </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
export default {
    name: "ProviderAuthRedirect",
    components: {Footer, Navbar},
    created() {
        let redirectUrl = this.$store.getters.getLoginRedirect;
        this.$store.commit('setLoginRedirect', null);

        this.$auth.oauth2({
            code: true, // Required
            redirect: redirectUrl,
            provider: 'google',
            url: 'auth/login/google/callback',
            fetchUser: true,
            rememberMe: true,
            data: {
                code: this.$route.query.code,
                state: this.$store.getters.getSelectedState,
            },
            state: this.$route.query.state
        });
    }
}
</script>

<style scoped>
p {
    font-size: 22px;
}
</style>